import { Injectable } from '@angular/core';
import * as fs from 'file-saver';
import * as Excel from 'exceljs';
import { recipeModel } from 'src/app/common/models/recipeDetailsModel';
import {
    VIEW_DETAILED_EXCELREPORT_PLM,
    DETAILS_POPUP_EXCELREPORT,
    PRODUCT_DETAILS_COLUMNS_EXCEL,
    VIEW_DETAILED_EXCELREPORT_NONPLM,
    DETAILS_POPUP_EXCELREPORT_NONPLM,
} from 'src/app/common/models/PureFnModel';
import { ExportPdfService } from './export-pdf.service';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root'
})
export class ExportReportExcelService {
    wb = new Excel.Workbook();
    detailsCount = 0;
    CommentsHyperLinks = [];
    raCommentsHyperLinks = [];
    raAssismentData;
    racommentwithouttag = '';
    divisionData = '';
    isPlm: boolean;
    constructor(private exportPdfService: ExportPdfService, private dataTrans: DataService) { }
    /* istanbul ignore next */
    setExcelTabs(requestView, isPlm) {
        this.wb = new Excel.Workbook();
        this.isPlm = isPlm;
        const sheetNames = this.isPlm ? ['RA Assessment Summary', 'Project Details', 'Request View', 'Detailed Report on Composition', 'Detailed Report on Product'] : ['RA Assessment Summary', 'Project Details', 'Request View', 'Detailed Report on Composition'];
        sheetNames.forEach(sheetName => {
            const ws = this.wb.addWorksheet(sheetName);
            if (sheetName !== 'Project Details') {
                this.setFormulationDetails(ws, recipeModel.rpcRefinementData);
            }
            this.addColumns(ws, sheetName, requestView);
            if (sheetName === 'Project Details') {
                this.setProjectDetails(ws, recipeModel.rpcRefinementData);
                this.setMarketDetails(ws, recipeModel.rpcRefinementData);
                ws.columns = [
                    { width: 26 },
                    { width: 35 },
                    { width: 30 },
                    { width: 30 },
                    { width: 30 },
                    { width: 30 },
                    { width: 30 },
                    { width: 30 },
                    { width: 30 },
                ];
            } else if (sheetName === 'RA Assessment Summary') {
                ws.columns = [
                    { width: 26 },
                    { width: 35 },
                    { width: 30 },
                    { width: 30 },
                    { width: 30 },
                    { width: 30 },
                    { width: 30 },
                    { width: 30 },
                    { width: 30 },
                ];
                this.setAssessmentSummary(ws, recipeModel.rpcRefinementData);
            }
            this.setHeaderBackground(ws, sheetName);
            ws.state = 'visible';
        });
    }
    /* istanbul ignore next */
    setAssessmentSummary(worksheet, f) {
        this.raAssismentData = this.dataTrans.reportComments;
        if (this.raAssismentData != null) {
            this.racommentwithouttag = this.handleSpecialCharactersComments(this.raAssismentData);
        }
        this.raCommnetSplitLinks(this.raAssismentData);
        const detailsRow = [
            worksheet.addRow(['RA Assessment Summary ', this.racommentwithouttag]),
            worksheet.addRow(['RA Assessment Summary Link 1', this.raCommentsHyperLinks[0]]),
            worksheet.addRow(['RA Assessment Summary Link 2', this.raCommentsHyperLinks[1]]),
            worksheet.addRow(['RA Assessment Summary Link 3', this.raCommentsHyperLinks[2]]),
            worksheet.addRow(['RA Assessment Summary Link 4', this.raCommentsHyperLinks[3]]),
            worksheet.addRow(['RA Assessment Summary Link 5', this.raCommentsHyperLinks[4]]),
            worksheet.addRow(['RA Assessment Summary Link 6', this.raCommentsHyperLinks[5]]),
            worksheet.addRow(['RA Assessment Summary Link 7', this.raCommentsHyperLinks[6]]),
        ];

    }
    /* istanbul ignore next */
    setProjectDetails(worksheet, f) {
        let comments = '';
        let displayComments = '';
        if (f.marketDetails.projDetail !== null) {
            comments = f.marketDetails.projDetail.requestComments === null ? '' : f.marketDetails.projDetail.requestComments;
            if (comments !== '') {
                this.splitLinks(comments);
                const temporalDivElement = document.createElement('div');
                // Set the HTML content with the providen
                temporalDivElement.innerHTML = comments;
                // Retrieve the text property of the element (cross-browser support)
                displayComments = temporalDivElement.textContent || temporalDivElement.innerText || '';
            }
        }
        this.splitLinks(comments);
        const detailsRow = [
            worksheet.addRow(['Market', ` ${f.marketDetails.marketName === null ? ' ' : f.marketDetails.marketName} `]),
            worksheet.addRow(['Project Name', ` ${f.marketDetails.projDetail === null ? ' ' : f.marketDetails.projDetail.projectName} `]),
            worksheet.addRow(['Project Type ', ` ${f.marketDetails.projDetail === null ? ' ' : f.marketDetails.projDetail.projectTypeDesc} `]),
            worksheet.addRow(['Project Description', ` ${f.marketDetails.projDetail === null ? ' ' : f.marketDetails.projDetail.projectDescription} `]),
            worksheet.addRow(['Brand', ` ${f.marketDetails.projDetail === null ? ' ' : f.marketDetails.projDetail.brandDesc} `]),
            worksheet.addRow(['Manufacturing Country', ` ${f.marketDetails.projDetail === null ? ' ' : f.marketDetails.projDetail.manufactureCountryDescription} `]),
            worksheet.addRow(['Manufacturing Sites', ` ${f.marketDetails.projDetail === null || f.marketDetails.projDetail.manuSite === null || f.marketDetails.projDetail.manuSite.length === 0 || f.marketDetails.projDetail.manuSite[0].othersitedesc === undefined || f.marketDetails.projDetail.manuSite.map(m => m.othersitedesc) === undefined ? '' : f.marketDetails.projDetail.manuSite.map((x) => x.othersitedesc).join(', ')} `]),
            worksheet.addRow(['Launch Timeline', ` ${f.marketDetails.projDetail === null ? ' ' : f.marketDetails.projDetail.launchTimeLine} `]),
            worksheet.addRow(['Comments', `${f.marketDetails.projDetail === null ? ' ' : displayComments} `]),
            worksheet.addRow(['R&D Comment Link 1', this.CommentsHyperLinks[0]]),
            worksheet.addRow(['R&D Comment Link 2', this.CommentsHyperLinks[1]]),
            worksheet.addRow(['R&D Comment Link 3', this.CommentsHyperLinks[2]]),
            worksheet.addRow(['R&D Comment Link 4', this.CommentsHyperLinks[3]]),
            worksheet.addRow(['R&D Comment Link 5', this.CommentsHyperLinks[4]]),
            worksheet.addRow(['R&D Comment Link 6', this.CommentsHyperLinks[5]]),
            worksheet.addRow(['R&D Comment Link 7', this.CommentsHyperLinks[6]]),
            worksheet.addRow([])
        ];
        this.detailsCount = detailsRow.length + 2;
    }
    /* istanbul ignore next */
    setFormulationDetails(worksheet, f) {
        if (f.recipeStatus === '000') {
            this.isPlm = false;
        } else {
            this.isPlm = true;
        }
        // this.isPlm = f.recipeStatus === '000' ? false : true;
        const skeyDate = f.marketDetails.projDetail === null || f.marketDetails.projDetail === undefined ? '' : f.marketDetails.projDetail.keyDate !== null ? f.marketDetails.projDetail.keyDate.split('T')[0] : '';
        const svalidityArea = f.marketDetails.projDetail === null || f.marketDetails.projDetail === undefined ? '' : f.marketDetails.projDetail.validityArea != null ? f.marketDetails.projDetail.validityArea : '';
        let detailsRow = [];
        if (this.isPlm) {
            detailsRow = [
                worksheet.addRow(['Request ID', f.requestDisplayID]),
                worksheet.addRow(['CUC Code/ALT/VER ', `${f.cucCode}/${f.cucAlt}/${f.cucVer}`]),
                worksheet.addRow(['Validity Area', svalidityArea]),
                worksheet.addRow(['Key Date', skeyDate]),
                worksheet.addRow(['TFC Path', f.tfc.tfcFullText]),
                worksheet.addRow(['Market', f.marketDetails.marketName]),
                worksheet.addRow(['Intended Use', f.intendedUse]),
                worksheet.addRow(['Preparation Method', f.preparationMethod]),
                worksheet.addRow(['Multi Component', `${f.isMultiComponent === 'N' ? 'No' : 'Yes'}`])
            ];
        } else {
            detailsRow = [
                worksheet.addRow(['Request ID', f.requestDisplayID]),
                worksheet.addRow(['Recipe ID ', `${f.cucCode}/${f.cucVer} `]),
                worksheet.addRow(['TFC Path', f.tfc.tfcFullText]),
                worksheet.addRow(['Market', f.marketDetails.marketName]),
                worksheet.addRow(['Intended Use', f.intendedUse]),
                worksheet.addRow(['Preparation Method', f.preparationMethod]),
                worksheet.addRow(['Multi Component', `${f.isMultiComponent === 'N' ? 'No' : 'Yes'}`]),
            ];
        }
        // set markets
        f.rpcLeafNodes.forEach(rpc => {
            detailsRow.push(worksheet.addRow([`RPC Refinement - ${rpc.market}`, `${rpc.isChecked === 'checked' ? rpc.fullText : ''}`]));
        });
        detailsRow.push(worksheet.addRow([`Overall Status`, `${this.exportPdfService.capitalize(recipeModel.rpcRefinementData.compositionOverallStatus)} ${this.isPlm ? '(Combination of composition and product)' : '(composition)'}`]));
        detailsRow.push(worksheet.addRow([]));
        this.detailsCount = detailsRow.length + 2;

    }
    /* istanbul ignore next */
    setMarketDetails(worksheet, f) {
        const skeyDate = f.marketDetails.projDetail === null || f.marketDetails.projDetail === undefined ? '' : f.marketDetails.projDetail.keyDate !== null ? f.marketDetails.projDetail.keyDate.split('T')[0] : '';
        const svalidityArea = f.marketDetails.projDetail === null || f.marketDetails.projDetail === undefined ? '' : f.marketDetails.projDetail.validityArea != null ? f.marketDetails.projDetail.validityArea : '';
        let detailsRow = [];
        if (this.isPlm) {
            detailsRow = [
                worksheet.addRow(['Request ID', f.requestDisplayID]),
                worksheet.addRow(['CUC Code/ALT/VER ', `${f.cucCode}/${f.cucAlt}/${f.cucVer} `]),
                worksheet.addRow(['Validity Area', svalidityArea]),
                worksheet.addRow(['Key Date', skeyDate]),
                worksheet.addRow(['TFC Path', f.tfc.tfcFullText]),
                worksheet.addRow(['Market', f.marketDetails.marketName]),
                worksheet.addRow(['Intended Use', f.intendedUse]),
                worksheet.addRow(['Preparation Method', f.preparationMethod]),
                worksheet.addRow(['Multi Component', `${f.isMultiComponent === 'N' ? 'No' : 'Yes'}`])
            ];
        } else {
            detailsRow = [
                worksheet.addRow(['Request ID', f.requestDisplayID]),
                worksheet.addRow(['Recipe ID ', `${f.cucCode}/${f.cucVer}`]),
                worksheet.addRow(['TFC Path', f.tfc.tfcFullText]),
                worksheet.addRow(['Market', f.marketDetails.marketName]),
                worksheet.addRow(['Intended Use', f.intendedUse]),
                worksheet.addRow(['Preparation Method', f.preparationMethod]),
                worksheet.addRow(['Multi Component', `${f.isMultiComponent === 'N' ? 'No' : 'Yes'}`]),
            ];
        }
        f.rpcLeafNodes.forEach(rpc => {
            detailsRow.push(worksheet.addRow([`RPC Refinement - ${rpc.market}`, `${rpc.isChecked === 'checked' ? rpc.fullText : ''}`]));
        });
        // overall status
        detailsRow.push(worksheet.addRow([`Overall Status`, `${this.exportPdfService.capitalize(recipeModel.rpcRefinementData.compositionOverallStatus)} ${this.isPlm ? '(Combination of composition and product)' : '(composition)'}`]));
        detailsRow.push(worksheet.addRow([]));
    }
    /* istanbul ignore next */
    addColumns(worksheet, sheetName, requestView) {
        this.divisionData = localStorage.getItem('division');
        let columns;
        let fullColumns = [];
        if (sheetName === 'Request View') {
            columns = this.isPlm ? VIEW_DETAILED_EXCELREPORT_PLM.map(c => c.header) : VIEW_DETAILED_EXCELREPORT_NONPLM.map(c => c.header);
            fullColumns = this.isPlm ? VIEW_DETAILED_EXCELREPORT_PLM.map(c => c) : VIEW_DETAILED_EXCELREPORT_NONPLM.map(c => c);
        } else if (sheetName === 'Detailed Report on Composition') {
            columns = this.isPlm ? DETAILS_POPUP_EXCELREPORT.map(c => c.header) : DETAILS_POPUP_EXCELREPORT_NONPLM.map(c => c.header);
            fullColumns = DETAILS_POPUP_EXCELREPORT.map(c => c);
        } else if (sheetName === 'Detailed Report on Product' && this.isPlm) {
            columns = PRODUCT_DETAILS_COLUMNS_EXCEL.map(c => c.header);
            fullColumns = PRODUCT_DETAILS_COLUMNS_EXCEL.map(c => c);
        }
        worksheet.addRow(columns);
        if (fullColumns.length > 0) {
            let colWidth = 1;
            fullColumns.forEach((col2) => {
                const col = worksheet.getColumn(colWidth);
                col.width = col2.width;
                colWidth++;
            });
        }
        this.addRows(worksheet, requestView, sheetName);
    }
    /* istanbul ignore next */
    addRows(worksheet, requestViewData, sheetName) {
        if (sheetName === 'Request View') {
            requestViewData.forEach(item => {
                if (this.isPlm) {
                    worksheet.addRow([
                        item.specID, item.specDescription, item.specQuantity, item.ingredientPath, item.ingDescription, item.pureCode, item.pureDescription, item.recipeQuantity, item.rndInputFunction, item.substanceFunctionInput, item.tooltip
                    ]);
                } else {
                    worksheet.addRow([
                        item.ingID, item.ingDescription, item.ingQuantity, item.pureCode, item.substanceName, item.substanceID, item.casNumber, item.inciNumber, item.einecsNumber, item.recipeQuantityToDisplay, item.recipeQuantity, item.specUoM, item.substanceFunctionInput, item.originatorComment, item.tooltip
                    ]);
                }
            });
        } else if (sheetName === 'Detailed Report on Composition') {
            recipeModel.rpcRefinementData.exportData.forEach(item => { this.setCompositionTabDetails(worksheet, item.compositionTabContent); });
        } else if (sheetName === 'Detailed Report on Product' && this.isPlm) {
            recipeModel.rpcRefinementData.exportData.forEach(item => { this.setProductTabDetails(worksheet, item.propertyProductViewDetailedReport); });
        }
    }
    /* istanbul ignore next */
    setCompositionTabDetails(worksheet, data) {
        data.forEach(composition => {
            this.setPures(worksheet, composition.viewAllPures);
        });
    }
    /* istanbul ignore next */
    setPures(worksheet, pures) {
        pures.forEach(pure => {
            let purecommentForDisplay = (pure.commentForDisplay === null || pure.commentForDisplay === '' || pure.commentForDisplay === undefined) ? '' : pure.commentForDisplay;
            if (purecommentForDisplay !== '') {
                purecommentForDisplay = this.handleSpecialCharacters(purecommentForDisplay);
            }
            let pureWarningTextdata = (pure.warningText === null || pure.warningText === '' || pure.warningText === undefined) ? '' : pure.warningText;
            let pureWarningText = [];
            if (pureWarningTextdata !== '') {
                pureWarningText = this.hyperLinksToSheet(pureWarningTextdata);
                pureWarningTextdata = this.handleSpecialCharacters(pureWarningTextdata);
            }
            let pureORR = (pure.otherRestrictionsAndRequirements === null || pure.otherRestrictionsAndRequirements === '' || pure.otherRestrictionsAndRequirements === undefined) ? '' : pure.otherRestrictionsAndRequirements;
            let pureORRHyperLinks = [];
            if (pureORR !== '') {
                pureORRHyperLinks = this.hyperLinksToSheet(pureORR);
                pureORR = this.handleSpecialCharacters(pureORR);
            }
            const ruleVersion = pure.ruleID > 0 ? 'V' + pure.ruleVersion : '';
            if (this.isPlm) {
                worksheet.addRow([
                    // tslint:disable-next-line:max-line-length
                    pure.tooltip, purecommentForDisplay, pureWarningTextdata, pure.groupApplicability, pure.pureCode, pure.pureDescription, pure.convertedRecipeQty, pure.finalUoM, pure.recipeQuantity, pure.recipeUoM, pure.inciNumber, pure.cfSubstanceExpressedAs, pure.cf, pure.isAllergen, pure.hazardClass, pure.marketNameForDisplay, pure.rpcListForDisplay, pure.ruleRPC, pure.ruleTypeDisplayName, pure.allowedFuncFlag, pure.rndInputFunction, pure.substanceFunctionInput, pure.equalityCondition, pure.minLimit, pure.maxLimit, pure.ruleUoM, pure.groupName, pure.isExempted, pure.conflictingSubstance, pure.combinationSubstance, pure.combinationRatioToDisplay, pure.ruleSpecificConditionName, pure.ruleClaimName, pure.phasingOutDate, pureORR, pure.propertySource, pure.propertyClass, pure.propertyName, pure.ingPropertyType, pure.ingPropertyName, pure.ruleSource, pure.validityDate, pure.substanceID, pure.casNumber, pure.parentCASNumber, pure.einecsNumber, pure.eNumber, pure.insNumber, pure.multiComponentName, pure.preparationMethod, pure.intendedUse, pure.groupID, pure.groupName, pure.ruleID, ruleVersion, pure.acidityAsAceticAcid, pure.aceticAcidUoM, pure.brixOfLemon, pure.brixOfLemonUoM, pureWarningText[0] !== undefined ? pureWarningText[0] : '', pureWarningText[1] !== undefined ? pureWarningText[1] : '', pureWarningText[2] !== undefined ? pureWarningText[2] : '', pureWarningText[3] !== undefined ? pureWarningText[3] : '', pureWarningText[4] !== undefined ? pureWarningText[4] : '', pureWarningText[5] !== undefined ? pureWarningText[5] : '', pureWarningText[6] !== undefined ? pureWarningText[6] : '', pureORRHyperLinks[0] !== undefined ? pureORRHyperLinks[0] : '', pureORRHyperLinks[1] !== undefined ? pureORRHyperLinks[1] : '', pureORRHyperLinks[2] !== undefined ? pureORRHyperLinks[2] : '', pureORRHyperLinks[3] !== undefined ? pureORRHyperLinks[3] : '', pureORRHyperLinks[4] !== undefined ? pureORRHyperLinks[4] : '', pureORRHyperLinks[5] !== undefined ? pureORRHyperLinks[5] : '', pureORRHyperLinks[6] !== undefined ? pureORRHyperLinks[6] : ''
                ]);
            } else {
                worksheet.addRow([
                    // tslint:disable-next-line:max-line-length
                    pure.tooltip, purecommentForDisplay, pureWarningTextdata, pure.groupApplicability, pure.pureCode, pure.pureDescription, pure.convertedRecipeQty, pure.finalUoM, pure.recipeQuantity, pure.recipeUoM, pure.inciNumber, pure.cfSubstanceExpressedAs, pure.cf, pure.isAllergen, pure.hazardClass, pure.marketNameForDisplay, pure.rpcListForDisplay, pure.ruleRPC, pure.ruleTypeDisplayName, pure.allowedFuncFlag, pure.rndInputFunction, pure.substanceFunctionInput, pure.equalityCondition, pure.minLimit, pure.maxLimit, pure.ruleUoM, pure.groupName, pure.isExempted, pure.conflictingSubstance, pure.combinationSubstance, pure.combinationRatioToDisplay, pure.ruleSpecificConditionName, pure.ruleClaimName, pure.phasingOutDate, pureORR, pure.propertySource, pure.propertyClass, pure.propertyName, pure.ingPropertyType, pure.ingPropertyName, pure.ruleSource, pure.validityDate, pure.substanceID, pure.casNumber, pure.parentCASNumber, pure.einecsNumber, pure.eNumber, pure.insNumber, pure.multiComponentName, pure.preparationMethod, pure.intendedUse, pure.groupID, pure.groupName, pure.ruleID, ruleVersion, pureWarningText[0] !== undefined ? pureWarningText[0] : '', pureWarningText[1] !== undefined ? pureWarningText[1] : '', pureWarningText[2] !== undefined ? pureWarningText[2] : '', pureWarningText[3] !== undefined ? pureWarningText[3] : '', pureWarningText[4] !== undefined ? pureWarningText[4] : '', pureWarningText[5] !== undefined ? pureWarningText[5] : '', pureWarningText[6] !== undefined ? pureWarningText[6] : '', pureORRHyperLinks[0] !== undefined ? pureORRHyperLinks[0] : '', pureORRHyperLinks[1] !== undefined ? pureORRHyperLinks[1] : '', pureORRHyperLinks[2] !== undefined ? pureORRHyperLinks[2] : '', pureORRHyperLinks[3] !== undefined ? pureORRHyperLinks[3] : '', pureORRHyperLinks[4] !== undefined ? pureORRHyperLinks[4] : '', pureORRHyperLinks[5] !== undefined ? pureORRHyperLinks[5] : '', pureORRHyperLinks[6] !== undefined ? pureORRHyperLinks[6] : ''
                ]);
            }
        });
    }
    /* istanbul ignore next */
    setProductTabDetails(worksheet, products) {
        products.forEach(product => {
            let purecommentForDisplay = (product.commentForDisplay === null || product.commentForDisplay === '' || product.commentForDisplay === undefined) ? '' : product.commentForDisplay;
            if (purecommentForDisplay !== '') {
                purecommentForDisplay = this.handleSpecialCharacters(purecommentForDisplay);
            }
            let productWarningTextdata = (product.warningText === null || product.warningText === '' || product.warningText === undefined) ? '' : product.warningText;
            let productWarningText = [];
            if (productWarningTextdata !== '') {
                productWarningText = this.hyperLinksToSheet(productWarningTextdata);
                productWarningTextdata = this.handleSpecialCharacters(productWarningTextdata);
            }
            let productORR = (product.otherRestrictionsAndRequirements === null || product.otherRestrictionsAndRequirements === '' || product.otherRestrictionsAndRequirements === undefined) ? '' : product.otherRestrictionsAndRequirements;
            let productORRHyperLinks = [];
            if (productORR !== '') {
                productORRHyperLinks = this.hyperLinksToSheet(productORR);
                productORR = this.handleSpecialCharacters(productORR);
            }
            worksheet.addRow([
                // tslint:disable-next-line:max-line-length
                product.tooltip, purecommentForDisplay, product.ruleID, product.ruleVersion, product.market, product.rpcPath, product.ruleRPC, product.ruleType, product.propertySource, product.property, product.subProperty, product.pureCode, product.pureDescription, product.inci, product.function, product.minValue, product.equalityCondition, product.maxValue, product.uom, product.claims, product.ruleSpecificConditionName, productWarningTextdata, productORR, product.substanceID, product.casNumber, product.parentCASNumber, product.einecsNumber, product.eNumber, product.insNumber, product.componentName, product.preparationMethod, product.intendedUse, product.ruleCreatedByUserDisplayName, product.ruleCreatedDate, product.ruleModifiedByUserDisplayName, product.ruleModifiedDate, product.source, product.validityDate, productWarningText[0] !== undefined ? productWarningText[0] : '', productWarningText[1] !== undefined ? productWarningText[1] : '', productWarningText[2] !== undefined ? productWarningText[2] : '', productWarningText[3] !== undefined ? productWarningText[3] : '', productWarningText[4] !== undefined ? productWarningText[4] : '', productWarningText[5] !== undefined ? productWarningText[5] : '', productWarningText[6] !== undefined ? productWarningText[6] : '', productORRHyperLinks[0] !== undefined ? productORRHyperLinks[0] : '', productORRHyperLinks[1] !== undefined ? productORRHyperLinks[1] : '', productORRHyperLinks[2] !== undefined ? productORRHyperLinks[2] : '', productORRHyperLinks[3] !== undefined ? productORRHyperLinks[3] : '', productORRHyperLinks[4] !== undefined ? productORRHyperLinks[4] : '', productORRHyperLinks[5] !== undefined ? productORRHyperLinks[5] : '', productORRHyperLinks[6] !== undefined ? productORRHyperLinks[6] : ''
            ]);
        });
    }
    /* istanbul ignore next */
    setHeaderBackground(worksheet, sheetName) {
        const tfcpathtooltip = 'The PLM TFC has been remapped/retired. Please create a new request with updated PLM TFC.';
        worksheet.eachRow((row, rowNumber) => {
            row.font = { size: 9 };
            row.eachCell((cell, colNumber) => {
                if (rowNumber < this.detailsCount - 1) {
                    if (sheetName !== 'Project Details') {
                        if (colNumber === 2 && rowNumber === 3 && localStorage.getItem('tfcStatus') === '0') {
                            cell.font = { size: 9, bold: true, color: { argb: 'e82532' } };
                            worksheet.getCell('B3').note = {
                                texts: [{ font: { size: 9, bold: true, color: { argb: 'e82532' } }, text: tfcpathtooltip }],
                                margins: {
                                    insetmode: 'auto',
                                },
                                protection: {
                                    locked: true,
                                    lockText: true
                                }
                            };
                        }
                        if (colNumber === 1) {
                            cell.font = { size: 9, bold: true };
                            cell.fill = { type: 'pattern', pattern: 'solid', bgColor: { argb: 'FFFFFF' }, fgColor: { argb: 'f8cbad' } };
                        }
                    } else if (sheetName === 'Project Details' && rowNumber < 18) {
                        if (colNumber === 1) {
                            cell.font = { size: 9, bold: true };
                            cell.fill = { type: 'pattern', pattern: 'solid', bgColor: { argb: 'FFFFFF' }, fgColor: { argb: 'aad5f0' } };
                        }
                        if (colNumber === 2 && rowNumber > 10 && rowNumber < 18) {
                            cell.font = { size: 9, bold: true, underline: true, color: { argb: '003e66' } };
                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                        }
                    }
                } else if (sheetName === 'Project Details' && rowNumber > 18) {
                    if (colNumber === 2 && rowNumber === 21 && localStorage.getItem('tfcStatus') === '0') {
                        cell.font = { size: 9, bold: true, color: { argb: 'e82532' } };
                        worksheet.getCell('B21').note = {
                            texts: [{ font: { size: 9, bold: true, color: { argb: 'e82532' } }, text: tfcpathtooltip }],
                            margins: {
                                insetmode: 'auto',
                            },
                            protection: {
                                locked: true,
                                lockText: true
                            }
                        };
                    }
                    if (colNumber === 1) {
                        cell.font = { size: 9, bold: true };
                        cell.fill = { type: 'pattern', pattern: 'solid', bgColor: { argb: 'FFFFFF' }, fgColor: { argb: 'f8cbad' } };
                    }
                } else if (sheetName === 'RA Assessment Summary' && rowNumber > 12) {
                    const detailsSummaryCount = this.detailsCount;
                    if (colNumber === 1) {
                        cell.font = { size: 9, bold: true };
                        cell.fill = { type: 'pattern', pattern: 'solid', bgColor: { argb: 'FFFFFF' }, fgColor: { argb: 'aad5f0' } };
                    }
                    if (colNumber === 2 && rowNumber > detailsSummaryCount) {
                        cell.font = { size: 9, bold: true, underline: true, color: { argb: '4168f2' } };
                        cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    }
                } else if (sheetName === 'RA Assessment Summary' && rowNumber < 12) {
                    if (colNumber === 1) {
                        cell.font = { size: 9, bold: true };
                        cell.fill = { type: 'pattern', pattern: 'solid', bgColor: { argb: 'f8cbad' }, fgColor: { argb: 'f8cbad' } };
                    }
                } else {
                    if (sheetName === 'Request View') {
                        if (colNumber === 10 && this.isPlm) {
                            cell.font = { color: { argb: 'FFFFFF' } };
                            cell.fill = { type: 'pattern', pattern: 'solid', bgColor: { argb: 'FFFFFF' }, fgColor: { argb: `${this.exportPdfService.getStatusColor(cell.value)}` } };
                        } else if (colNumber === 13 && !this.isPlm) {
                            cell.font = { color: { argb: 'FFFFFF' } };
                            cell.fill = { type: 'pattern', pattern: 'solid', bgColor: { argb: 'FFFFFF' }, fgColor: { argb: `${this.exportPdfService.getStatusColor(cell.value)}` } };
                        }
                    } else if (sheetName === 'Detailed Report on Composition') {
                        if (colNumber >= 60 && rowNumber > 12) {
                            cell.font = { size: 9, bold: true, underline: true, color: { argb: '4168f2' } };
                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                        }
                    } else if (sheetName === 'Detailed Report on Product' && this.isPlm) {
                        if (colNumber >= 39 && rowNumber > 12) {
                            cell.font = { size: 9, bold: true, underline: true, color: { argb: '4168f2' } };
                            cell.alignment = { vertical: 'middle', horizontal: 'center' };
                        }
                    } else {
                        if (colNumber === 1) {
                            cell.font = { color: { argb: 'FFFFFF' } };
                            cell.fill = { type: 'pattern', pattern: 'solid', bgColor: { argb: 'FFFFFF' }, fgColor: { argb: `${this.exportPdfService.getStatusColor(cell.value)}` } };
                        }
                    }
                }
            });
        });
        if (sheetName !== 'Project Details') {
            worksheet.getRow(this.detailsCount - 1).fill = {
                type: 'gradient', gradient: 'angle', degree: 0, stops: [{ position: 0, color: { argb: 'f8cbad' } }, { position: 1, color: { argb: 'f8cbad' } }]
            };
        }
        // commented for now as it is not required because below code make invisible the request id.
        // worksheet.getRow(1).fill = {
        //     type: 'gradient', gradient: 'angle', degree: 0, stops: [{ position: 0, color: { argb: 'ffffff' } }, { position: 1, color: { argb: 'ffffff' } }]
        // };
        // worksheet.getRow(1).font = { color: { argb: 'ffffff' } };
        worksheet.getRow(this.detailsCount - 1).font = { size: 9, bold: true };
    }
    /* istanbul ignore next */
    downloadExcel() {
        this.wb.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, `Report-${recipeModel.requestDisplayID}.xlsx`);
        });
    }
    /* istanbul ignore next */
    handleSpecialCharacters(inputData) {
        return inputData.replace(/<.*?>/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;.*?/gi, '').replace(/&amp;/g, '&');
    }
    /* istanbul ignore next */
    handleSpecialCharactersComments(text) {
        return text.replace(/<p>|<\/p>/g, '\n').replace(/<.*?>/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;.*?/gi, ' ').replace(/&amp;/g, '&');
    }
    /* istanbul ignore next */
    splitLinks(comment) {
        const regex = /<a[^>]*href=["']([^"']*)["']/gm;
        const aregText = /<a(.*?)<\/a>/gm;
        this.CommentsHyperLinks = [];
        let m;
        let getAncharText;
        const totalAnchor = [1, 2, 3, 4, 5, 6, 7];
        const textbetweenTags = [];
        for (const val of totalAnchor) {
            getAncharText = aregText.exec(comment);
            if (getAncharText == null) {
                break;
            }
            if (getAncharText.index === aregText.lastIndex) {
                aregText.lastIndex++;
            }

            getAncharText.forEach((amatch, agroupIndex) => {
                if (agroupIndex === 1) {
                    const aindex = amatch.indexOf('>');
                    const matchLength = amatch.length;
                    textbetweenTags.push(amatch.substring(aindex + 1, matchLength));
                }
            });
        }
        let index = 0;

        for (const val of totalAnchor) {
            m = regex.exec(comment);
            if (m == null) {
                break;
            }
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            m.forEach((match, groupIndex) => {
                if (groupIndex === 1) {
                    this.CommentsHyperLinks.push(
                        {
                            text: this.handleSpecialCharactersForHyperlinks(textbetweenTags[index]),
                            hyperlink: match,
                            tooltip: match
                        });
                    index = index + 1;
                }
            });
        }
    }
    /* istanbul ignore next */
    raCommnetSplitLinks(comment) {
        const regex = /<a[^>]*href=["']([^"']*)["']/gm;
        const aregText = /<a(.*?)<\/a>/gm;
        this.raCommentsHyperLinks = [];
        let m;
        let getraAncharText;
        const totalAnchor = [1, 2, 3, 4, 5, 6, 7];
        const textbetweenTags = [];
        for (const val of totalAnchor) {
            getraAncharText = aregText.exec(comment);
            if (getraAncharText == null) {
                break;
            }
            if (getraAncharText.index === aregText.lastIndex) {
                aregText.lastIndex++;
            }

            getraAncharText.forEach((amatch, agroupIndex) => {
                if (agroupIndex === 1) {
                    const aindex = amatch.indexOf('>');
                    const matchLength = amatch.length;
                    textbetweenTags.push(amatch.substring(aindex + 1, matchLength));
                }
            });
        }
        let index = 0;

        for (const val of totalAnchor) {
            m = regex.exec(comment);
            if (m == null) {
                break;
            }
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            m.forEach((match, groupIndex) => {
                if (groupIndex === 1) {
                    this.raCommentsHyperLinks.push(
                        {
                            text: this.handleSpecialCharactersForHyperlinks(textbetweenTags[index]),
                            hyperlink: match,
                            tooltip: match,
                            color: 'red'

                        });
                    index = index + 1;
                }
            });
        }
    }
    /* istanbul ignore next */
    async generateReport(requestView, isPlm = true) {
        this.setExcelTabs(requestView, isPlm);
        setTimeout(() => {
            this.downloadExcel();
        }, 2000);
    }

    /* istanbul ignore next */
    handleSpecialCharactersForHyperlinks(text) {
        if (text !== null && text !== '') {
            return text.replace(/&nbsp;.*?/gi, ' ').replace(/&amp;/g, '&').replace(/<strong>/gi, '').replace(/<\/strong>/gi, '').replace(/<i>/gi, '').replace(/<\/i>/gi, '');
        } else {
            return '';
        }
    }
    /* istanbul ignore next */
    hyperLinksToSheet(comment) {
        const regex = /<a[^>]*href=["']([^"']*)["']/gm;
        const aregText = /<a(.*?)<\/a>/gm;
        const hyperLinksData = [];
        let m;
        let getraAncharText;
        const totalAnchor = [1, 2, 3, 4, 5, 6, 7];
        const textbetweenTags = [];
        for (const val of totalAnchor) {
            getraAncharText = aregText.exec(comment);
            if (getraAncharText == null) {
                break;
            }
            if (getraAncharText.index === aregText.lastIndex) {
                aregText.lastIndex++;
            }

            getraAncharText.forEach((amatch, agroupIndex) => {
                if (agroupIndex === 1) {
                    const aindex = amatch.indexOf('>');
                    const matchLength = amatch.length;
                    textbetweenTags.push(amatch.substring(aindex + 1, matchLength));
                }
            });
        }
        let index = 0;

        for (const val of totalAnchor) {
            m = regex.exec(comment);
            if (m == null) {
                break;
            }
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            m.forEach((match, groupIndex) => {
                if (groupIndex === 1) {
                    hyperLinksData.push(
                        {
                            text: this.handleSpecialCharactersForHyperlinks(textbetweenTags[index]),
                            hyperlink: match,
                            tooltip: match,
                            color: 'red'

                        });
                    index = index + 1;
                }
            });
        }
        return hyperLinksData;
    }
}
